import { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useLanguage } from '../i18n/LanguageContext';

const BlogPage = () => {
  const { t } = useLanguage();

  useEffect(() => {
    // Load TrySoro blog script
    const script = document.createElement('script');
    script.src = 'https://app.trysoro.com/api/embed/9125b99b-9443-4fb1-992e-bb4dcc48ec57';
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script when component unmounts
      const existingScript = document.querySelector(`script[src="${script.src}"]`);
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <>
      <Navbar />
      
      <div className="min-h-screen bg-gray-50">
        {/* Hero Section */}
        <div className="bg-[#1D4E41] text-white py-16 pt-32">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">{t('blog.title')}</h1>
            <p className="text-xl text-white/80 max-w-2xl mx-auto">
              {t('blog.subtitle')}
            </p>
          </div>
        </div>

        {/* Blog Content from TrySoro */}
        <div className="container mx-auto px-4 py-12 max-w-6xl">
          <div id="soro-blog" className="min-h-[400px]">
            {/* TrySoro will inject blog content here */}
            <div className="flex items-center justify-center py-20">
              <div className="animate-pulse text-gray-400">{t('blog.loading')}</div>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </>
  );
};

export default BlogPage;
